import React, { Component } from "react";
import { DataGrid, GridColumn, Panel, ComboBox, LinkButton } from "rc-easyui";
import PropTypes from "prop-types";
import { API_URL } from "../../../constants";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { isEmpty, getFormattedDate } from "../../../helpers";

const axios = require("axios");

export default class View extends Component {
  static propTypes = {
    selectedRow: PropTypes.object,
    OnEditClick: PropTypes.func,
    onSelectionChange: PropTypes.func,
    permissions: PropTypes.array,
    enabled: PropTypes.array,
    clientsList: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.refereshData = this.refereshData.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.searchFieldOnChange = this.searchFieldOnChange.bind(this);
    this.getMaintainanceData = this.getMaintainanceData.bind(this);

    this.state = {
      data: [],
      pageOptions: {},
      searchparam: {
        srchClient: null,
        srchStatus: null,
      },
    };
  }

  componentDidMount() {
    this.setState(
      {
        pageOptions: {
          loading: true,

          pageOptions: {
            pageNumber: 1,
            pageSize: 10,
            layout: [
              "list",
              "sep",
              "first",
              "prev",
              "next",
              "last",
              "sep",
              "refresh",
              "sep",
              "manual",
              "info",
            ],
          },
        },
      },
      () => {
        this.getMaintainanceData();
      }
    );
  }

  async getMaintainanceData() {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/allmaintenancemode `;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          //console.log("response data",response);
          let data = response.data;
          if (response.status === 200 && data.length > 0) {
            //console.log(data);
            this.setState({
              data: data,
              pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: false,
              },
            });
          } else {
            this.setState({
              pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: false,
              },
            });
          }
        })
        .catch((error) => {
          this.setState({
            pageOptions: {
              pageOptions: {
                ...this.state.pageOptions.pageOptions,
              },
              loading: false,
            },
          });
        });
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getMaintainanceData();
      }
    }
  }

  async refereshData() {
    const { pageNumber, pageSize } = this.state.pageOptions.pageOptions;
    const { srchClient, srchStatus } = this.state.searchparam;
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/getmaintenancemodes?page=${pageNumber}&rows=${pageSize}&clientname=${srchClient}&status=${srchStatus}`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          let data = response.data.rows;
          if (response.status === 200 && data.length > 0) {
            this.setState({
              data: data,
              pageOptions: {
                pageOptions: {
                  pageSize: Math.min(10, 50, 30, 100, data.length),
                  total: response.data.total,
                  pageList: [10, 50, 30, 100, data.length].sort(function (
                    a,
                    b
                  ) {
                    return a - b;
                  }),
                  ...this.state.pageOptions.pageOptions,
                },
                loading: false,
              },
            });
          } else {
            this.setState({
              pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: false,
              },
            });
          }
        })
        .catch((error) => {
          this.setState({
            pageOptions: {
              pageOptions: {
                ...this.state.pageOptions.pageOptions,
              },
              loading: false,
            },
          });
        });
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.refereshData();
      }
    }
  }

  onPageChange(event) {
    //delete event["refresh"];
    delete event["filterRules"];
    //console.log(event);
    this.setState(
      {
        pageOptions: {
          pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
          loading: true,
        },
      },
      function () {
        this.refereshData();
      }
    );
  }

  searchFieldOnChange(name, e) {
    let searchparam = Object.assign({}, this.state.searchparam);
    searchparam[name] = e;
    this.setState({ searchparam: searchparam });
  }

  render() {
    const searchparam = this.state.searchparam;
    return (
      <div>
        <Panel
          title='Client List'
          bodyStyle={{ padding: 0 }}
          style={{ height: 567 }}
        >
          <DataGrid
            data={this.state.data}
            style={{ height: 500 }}
            selectionMode='single'
            {...this.state.pageOptions}
            pagination
            onPageChange={this.onPageChange}
            {...this.props.selectedRow}
            onSelectionChange={(selection) =>
              this.props.onSelectionChange(selection)
            }
            toolbar={({ editingItem }) => (
              <div style={{ padding: 4 }}>
                <b>Client Name </b>&nbsp;
                <ComboBox
                  style={{ width: 200 }}
                  data={this.props.clientsList}
                  valueField='organizationname'
                  textField='organizationname'
                  value={searchparam.srchClient}
                  onChange={(e) => this.searchFieldOnChange("srchClient", e)}
                ></ComboBox>
                &nbsp;
                <b>Status</b>&nbsp;
                <ComboBox
                  data={this.props.enabled}
                  valueField='value'
                  textField='text'
                  value={searchparam.srchStatus}
                  editable={false}
                  onChange={(e) => this.searchFieldOnChange("srchStatus", e)}
                ></ComboBox>
                &nbsp;
                <LinkButton
                  iconCls='icon-search'
                  plain
                  onClick={this.refereshData}
                >
                  Search
                </LinkButton>
                {this.props.permissions.includes(
                  "active-maintainance-mode-edit"
                ) ? (
                  <LinkButton
                    iconCls='icon-edit'
                    plain
                    disabled={isEmpty(this.props.selectedRow)}
                    onClick={this.props.OnEditClick}
                  >
                    Edit
                  </LinkButton>
                ) : (
                  ""
                )}
              </div>
            )}
          >
            <GridColumn
              field='rn'
              align='center'
              width='30px'
              cellCss='datagrid-td-rownumber'
              render={({ rowIndex }) => <span>{rowIndex + 1}</span>}
            />

            <GridColumn field='clientId' title='Client Id'></GridColumn>
            <GridColumn field='organaizationName' title='Name'></GridColumn>
            <GridColumn
              field='startDate'
              title='Start Date'
              render={({ row }) => (
                <span>{getFormattedDate(row.startDate)}</span>
              )}
            ></GridColumn>
            <GridColumn
              field='endDate'
              title='End Date'
              render={({ row }) => <span>{getFormattedDate(row.endDate)}</span>}
            ></GridColumn>
            <GridColumn
              field='enabled'
              title='Status'
              render={({ row }) => (
                <span>{row.enabled ? "Activate" : "Deactivate"}</span>
              )}
            ></GridColumn>
          </DataGrid>
        </Panel>
      </div>
    );
  }
}
